<script>
import HelpHint from 'dashboard/components/MesselloHelp/HelpHint.vue';

export default {
  components: { HelpHint },
  props: {
    headerTitle: { type: String, default: '' },
    headerContent: { type: String, default: '' },
    helpSlug: { type: String, default: '' },
    helpTitle: { type: String, default: '' },
  },
};
</script>

<template>
  <div class="flex flex-col gap-1.5 w-full items-start mb-4">
    <h2 class="text-heading-1 text-n-slate-12 break-words">
      {{ headerTitle }}
      <HelpHint
        v-if="helpSlug"
        :slug="helpSlug"
        :title="helpTitle || headerTitle"
      />
    </h2>
    <p
      v-dompurify-html="headerContent"
      class="text-body-main w-full text-n-slate-11"
    />
  </div>
</template>
